import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    authSelector,
    chapterMemberSelector,
    chapterSelector,
    dkpSelector,
    eventSelector,
    locationSelector, userSelector
} from '../redux/selectors'

import { openChapters, toArray } from '../common/util';
import { hasPermission } from "../common/permissions";
import { fetchChapterMembers, fetchEvents, fetchRecentEvents, fetchLocations, fetchSections, postEvent } from "../redux/actions";
import EventsForm from './EventsForm';
import EventsActive from './EventsActive';

class Events extends Component {
    constructor(props) {
        super(props);

        this.eventSubmit = this.eventSubmit.bind(this);
    }
    componentDidMount() {
        document.title = "Addiction | Guild Management | DKP | Events";
        openChapters(this.props.chapters)
            .filter(chapter => chapter.game.title !== "Addiction")
            .map((chapter) => {
                this.props.getSections(chapter.id);
                this.props.getLocations(chapter.id);
                this.props.getRecentEvents(chapter.id);
                return null;
            });
    }

    eventSubmit(values) {
        if (toArray(this.props.users).filter((user) => user.displayName.toLowerCase() === values.eventLeader.toLowerCase()).length === 1) {
            let newValues = {
                ...values,
                eventLeader: toArray(this.props.users).filter((user) => user.displayName.toLowerCase() === values.eventLeader.toLowerCase())[0].id,
                location: values.location.map((loc) => toArray(this.props.locations.data).filter((location) => location.id === loc)[0]),
                section: toArray(this.props.dkp.data).filter((section) => section.id === values.section)[0]

            };
            this.props.submitEvent(this.props.chapters[this.props.dkp.data[values.section].chapter].id, this.props.dkp.data[values.section].slug, newValues)
        }
    }


    render() {
        if (hasPermission('dkp.add_event', this.props.auth.permissions) || hasPermission('dkp.change_event', this.props.auth.permissions)) {
            return (
                <div>
                    <h1>Event Manager</h1>
                    <div className="panel-adt">
                        <h2>Active Events</h2>
                        {toArray(this.props.dkp.data)
                            .filter((section) => section.closed === false)
                            .map((section) => (
                                <div>
                                    <h3>{section.title}</h3>
                                    <EventsActive chapter={this.props.chapters[section.chapter].id} section={section} />
                                </div>
                            ))
                        }
                    </div>
                    {this.props.events.data ? (
                        <EventsForm initialValues={{ standbyRate: 0.5 }} onSubmit={this.eventSubmit} sections={this.props.dkp.data} locations={this.props.locations.data} events={this.props.events} chapters={this.props.chapters} chapterMembers={this.props.chapterMembers} users={this.props.users} errors={this.props.errors} getMembers={this.props.getChapterMembers} />
                    ) : null
                    }
                </div>
            )
        } else {
            return <Redirect to="/" />
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    chapters: chapterSelector(state),
    dkp: dkpSelector(state),
    events: eventSelector(state),
    locations: locationSelector(state),
    chapterMembers: chapterMemberSelector(state),
    users: userSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getEvents: (chapter, section, page) => dispatch(fetchEvents(chapter, section, page)),
    getRecentEvents: (chapter) => dispatch(fetchRecentEvents(chapter)),
    getSections: (chapter) => dispatch(fetchSections(chapter)),
    getLocations: (chapter) => dispatch(fetchLocations(chapter)),
    getChapterMembers: (chapter) => dispatch(fetchChapterMembers(chapter)),
    submitEvent: (chapter, section, event) => dispatch(postEvent(chapter, section, event))
});

export default connect(mapStateToProps, mapDispatchToProps)(Events);


// WEBPACK FOOTER //
// ./src/Officer/Events.js